/* 
 * 组件：评论列表项
 * 作者：高苗飞
*/ 
<template>
  <div class="act-talk">
    <div class="act-title">
      <div class="act-flex act-vcenter act-htg100">
        <div>
          <img :src="dataSource.avatar" class="act-logo">
        </div>
        <div class="act-padL16 act-table">
          <div class="act-cell act-left act-padL0">
            <p class="act-username act-pad8">{{dataSource.author}}</p>
            <p class="act-date act-pad8">{{dataSource.commentTime}}</p>
          </div>
          <div class="act-cell act-right act-pad0">
            <!-- <img :src="supportImg" class="act-support">
            <span class="act-font16 act-pad8">26</span> -->
          </div>
        </div>
      </div>
    </div>
    <div class="act-watchText act-padL89 act-lineHtg40">
      <p>{{dataSource.commentContent}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BuscDiscussCard',
  props: {
    dataSource: {
      type: Object,
      default: function() {
        return {
          num: '',
          talkinfo: '',
          avatar: '',
          commentContent: '',
          commentId: '',
          commentTime: ''
        };
      }
    }
  },
  data() {
    return {
      userImg: '../../images/shopping_active.png',
      supportImg: '../../images/support.png'
    };
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';

.act-talk {
  width: 100%;
  background: #ffffff;
  position: relative;
  padding: 0 $rem32 $rem24 $rem32;
  // padding-top: $rem60;
}
.act-talkTitle {
  font-size: $rem30;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
}
.act-table {
  display: table;
  width: 100%;
  height: 100%;
}
.act-left {
  text-align: left;
}
.act-right {
  text-align: right;
}
.act-font16 {
  font-size: $rem16;
  color: #666666;
}
.act-lineHtg40 {
  line-height: $rem40;
}
.act-htg32 {
  height: $rem32;
}
.act-pad0 {
  padding: 0 !important;
}
.act-pad8 {
  padding: $rem8;
}
.act-padL89 {
  padding-left: $rem89;
}
.act-wth100 {
  width: 100%;
}
.act-htg100 {
  height: 100%;
}
.act-floatL {
  float: left;
}

.act-floatR {
  float: right;
}

.act-title {
  width: 100%;
  height: $rem110;
  .act-logo {
    width: $rem64;
    height: $rem64;
    border-radius: 50% 50%;
  }
}

.act-date {
  font-size: $rem24;
  color: #999999;
  letter-spacing: 0;
  line-height: $rem24;
}

.act-flex {
  display: flex;
}

.act-vcenter {
  align-items: center;
  justify-items: center;
}

.act-padL16 {
  padding-left: $rem16;
}

.act-cell {
  display: table-cell;
  vertical-align: middle;
  // padding: $rem56;
}

.act-padL0 {
  padding-left: 0;
}

.act-username {
  font-size: $rem24;
  color: #333333;
  letter-spacing: 0;
  line-height: $rem24;
}

.act-watchText {
  font-size: $rem26;
  color: #333333;
  letter-spacing: 0;
}

.act-support {
  width: $rem28;
  height: auto;
  display: inline-block;
}
</style>
